var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 95 50",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#F5AF02",
    d: "M70.4 32c0 1.4 0 2.7.2 4h-4.4c-.1-1-.2-2-.2-3-2.4 2.9-5.2 3.8-9.2 3.8-5.8 0-9-3.1-9-6.6 0-5.2 4.2-7 11.6-7.2 2 0 4.3-.1 6.2-.1v-.5c0-3.5-2.2-4.9-6.1-4.9-2.9 0-5 1.2-5.2 3.2h-5c.5-5.1 5.9-6.4 10.6-6.4 5.6 0 10.4 2 10.4 8V32zm-10.5-5.9c-4.3.1-7 .9-7 3.7 0 1.8 1.5 3.8 5.2 3.8 5 0 7.6-2.7 7.6-7.2v-.5c-1.7.1-3.9.1-5.8.2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#E4002B",
    d: "M4.8 26.7c.3 4.3 3.2 6.8 7.3 6.8 2.8 0 5.3-1.2 6.2-3.7h4.9c-1 5.1-6.4 6.8-11 6.8C3.7 36.7 0 32.1 0 25.8c0-6.9 3.9-11.5 12.3-11.5 6.7 0 11.6 3.5 11.6 11.1v1.3H4.8zm14.1-3.1c-.2-4.4-3.4-6.1-6.8-6.1-3.7 0-6.6 1.9-7.1 6.1h13.9z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#0064D2",
    d: "M23.9 6h4.7v11.9c2.3-2.8 5.5-3.6 8.7-3.6 5.3 0 11.1 3.6 11.1 11.3 0 6.4-4.7 11.1-11.2 11.1-3.4 0-6.7-1.2-8.7-3.7 0 1-.1 2-.2 2.9h-4.7c.1-1.5.2-3.4.2-4.9V6zM36 33.5c4.4 0 7.4-3.2 7.4-8s-3-8-7.4-8-7.4 3.2-7.4 8 3 8 7.4 8"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#84BD00",
    d: "M94.6 15.1L79.9 43.9h-5.3l4.2-8-11-20.8h5.5l8.2 16.3 8-16.3z"
  })));
}

export default SvgLogo;